import axios from "axios";
import { type IDomainsDataService } from "../types/services";
import { type AddDomainToAccountRequest } from "../types/requests";
import { type WithPagedDataV2 } from "../../../../../interfaces/getPagedDataRequest";
import {
  type AccountDomain,
  type AvailableDomainsConfiguration,
  type AvailableDomainsPoolsConfiguration,
  type DomainApiResponse,
} from "../types/state";
import { type DistributedOperationResult } from "types";

const threatDefenceUrl = "/api/v2/threat-defence";

const instance: IDomainsDataService = {
  addDomainToAccountsAsync: async (request: AddDomainToAccountRequest) => {
    const response = await axios.post<DistributedOperationResult>(`${threatDefenceUrl}/domains/accounts`, request);
    return response.data;
  },
  getAccountAvailableDomainsAsync: async (accountId: number) => {
    const response = await axios.get<AvailableDomainsConfiguration>(
      `${threatDefenceUrl}/domains/accounts/${accountId}/available-domains`,
    );
    return response.data;
  },
  getAccountAvailableDomainPoolsAsync: async () => {
    const response = await axios.get<AvailableDomainsPoolsConfiguration>(
      `${threatDefenceUrl}/domain-pools/accounts/domains`,
    );
    return response.data;
  },

  getAccountDomainAsync: async (accountId: number) => {
    const response = await axios.get<AccountDomain>(`${threatDefenceUrl}/domains/account/${accountId}/domain`);
    return response.data;
  },
  getDomainsAsync: async (request: WithPagedDataV2<{}>) => {
    const countHeaderName = process.env.REACT_APP_COUNT_HEADER_NAME as string;
    const config = {
      params: request,
    };
    const response = await axios.get<DomainApiResponse[]>(`${threatDefenceUrl}/domains`, config);

    const items = response.data;
    const totalCount = Number.parseInt(response.headers[countHeaderName]) || items.length;

    return { items, totalCount };
  },
};

export default instance;
